module.exports = __webpack_public_path__ + "img/vampire2_strip1_keyframes.1560ab59.gif";